import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import TenantContext from './tenantContext';
import { useBasicFetch } from './fetchHookNoToken';
import LoaderInner from '../components/LoaderInner';
import { mockTenantData as wlTenantDefaults } from '../data/mockData/wlDemoData';
import { setBranding } from '../redux/branding/action';
import { applyBrandingCssVars } from './sidebarBrandingColors';

function tenantPayloadFromFetch(info) {
  if (!info || typeof info !== 'object') {
    return {};
  }
  if (info.detail != null && info.id == null) {
    return {};
  }
  if (typeof info.count === 'number' && Array.isArray(info.results) && info.count > 0) {
    return info.results[0] && typeof info.results[0] === 'object' ? info.results[0] : {};
  }
  if (info.id != null) {
    return info;
  }
  return {};
}

const THEME_COLOR = "#000a60";
const DEFAULT_SIDEBAR_COLOR = "#ffffff";
const DEFAULT_FONT_FAMILY = '"Nunito Sans", sans-serif';

function loadGoogleFont(fontFamilyValue) {
  try {
    const raw = (fontFamilyValue || "").split(",")[0].replace(/['"]/g, "").trim();
    if (!raw) {
      return;
    }
    const id = `tenant-gf-${raw.replace(/\s+/g, "-")}`;
    if (document.getElementById(id)) {
      return;
    }
    const urlFamily = `${raw.replace(/\s+/g, "+")}:wght@300;400;500;600;700`;
    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?family=${urlFamily}&display=swap`;
    document.head.appendChild(link);
  } catch (e) {}
}

const TenantProvider = ({ children }) => {
  const dispatch = useDispatch();
  const brandingFromStore = useSelector(state => state.branding?.data);
  const [tenant, setTenant] = useState({});
  const [tenantInfo] = useBasicFetch("GET", "tenants/");
  const [isLoading, setIsLoading] = useState(true);
  const tenantValue = { tenant, setTenant };

  useEffect(() => {
    const fromApi = tenantPayloadFromFetch(tenantInfo);
    setTenant({ ...wlTenantDefaults, ...fromApi });
    setIsLoading(false);
  }, [tenantInfo]);

  useEffect(() => {
    const tenantBranding = tenant?.branding || {};
    dispatch(setBranding(tenantBranding));
  }, [tenant, dispatch]);

  useEffect(() => {
    const branding = brandingFromStore || {};
    const themeColor = branding.first_color || THEME_COLOR;
    const sidebarColor = branding.sidebar_color_fe || DEFAULT_SIDEBAR_COLOR;
    const fontFamily = branding.font_family_fe || DEFAULT_FONT_FAMILY;
    const infoColor = branding.info_color_fe;
    const successColor = branding.success_color_fe;
    const warningColor = branding.warning_color_fe;
    const dangerColor = branding.danger_color_fe;
    const scooterColor = branding.scooter_color_fe;
    const buttonStyle = branding.button_style_fe;

    if (typeof document !== "undefined" && document.documentElement) {
      applyBrandingCssVars(document.documentElement, {
        themeColor,
        sidebarColor,
        infoColor,
        successColor,
        warningColor,
        dangerColor,
        scooterColor,
        buttonStyle,
      });
      document.documentElement.style.setProperty("--tenant-font-family", fontFamily);
      loadGoogleFont(fontFamily);
    }
  }, [brandingFromStore]);

  if (isLoading) {
    return <LoaderInner show={isLoading} />;
  }

  return (
    <TenantContext.Provider value={tenantValue}>
      {children}
    </TenantContext.Provider>
  );
};

export default TenantProvider;
